import React from "react";
import { MultiPickerListProps } from "../props";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { LinkedArtistPanelInstructionBase } from "./model";
import { AxiosResponse } from "axios";
import { useIsExternal } from "common/SessionContext";

interface Props<T extends LinkedArtistPanelInstructionBase> extends MultiPickerListProps<server.dto.ArtistSmall> {
  initialInstruction: T;
  listFunc: (instruction: T) => Promise<AxiosResponse<server.dto.ApiResponseWrapperWithRequest<server.dto.ArtistSmall[], server.dtofilters.ListLinkedArtistFilters>, any>>;
}

const MultiLinkedArtistList = <T extends LinkedArtistPanelInstructionBase>(props: Props<T>) => {
  const [instruction, setInstruction] = React.useState<T>({
    page: 1,
    perPage: 20,
    onlyFavorite: false,
    keyword: undefined,
    ...props.initialInstruction,
  });

  const setOnlyFavorite = (onlyFavorite: boolean) => { setInstruction(instr => ({ ...instr, onlyFavorite, page: 1 })); };

  const isExternalUser = useIsExternal();

  return <>
    <MultiPickerListWithSelectedItems
      instruction={instruction}
      onInstructionChange={i => setInstruction(i)}
      queryKey="artistpickerlist"
      api={props.listFunc}
      getError={() => undefined}
      excludeKeys={props.excludeKeys}
      getId={artist => artist.artistId}
      renderListItem={artist => <div>{artist.name}</div>}
      hideKeywordFilter={isExternalUser}
      otherFilters={isExternalUser ? undefined : <Checkbox label={RESX.GeneralLabels.OnlyFavorites} checked={instruction.onlyFavorite} onChange={(_, checked) => setOnlyFavorite(checked)} />}

      onChange={props.onChange}
      getLabel={(artist) => <div>{artist.name}</div>}
      value={props.value}
    />
  </>;
};

export default MultiLinkedArtistList;